import {useEffect} from 'react';

export function useBodyClassName(
  className: string | undefined,
  enabled = true,
) {
  useEffect(() => {
    if (!className || !enabled) {
      return;
    }
    const classes = className.split(/\s+/).filter(Boolean);
    document.body.classList.add(...classes);

    return () => {
      document.body.classList.remove(...classes);
    };
  }, [className, enabled]);
}
